const theme = {
  colors: {
    // Identidade Meta Globaltech
    primary: '#570d21',
    primaryHover: '#8b1a35',
    primaryLight: '#c41e3a',
    primaryMuted: '#f5e6ea',

    // Superfícies
    background: '#ffffff',
    surface: '#fafafa',
    surfaceHover: '#f4f4f5',

    // Texto
    title: '#1a1a1a',
    text: '#374151',
    textMuted: '#6b7280',
    textInverse: '#ffffff',

    // Bordas
    border: '#e5e7eb',
    borderFocus: '#570d21',

    // Feedback
    success: '#16a34a',
    successBg: '#f0fdf4',
    warning: '#d97706',
    warningBg: '#fffbeb',
    error: '#dc2626',
    errorBg: '#fef2f2',
    info: '#2563eb',
    infoBg: '#eff6ff',

    // Sombras (via tokens de cor)
    shadowColor: 'rgba(0, 0, 0, 0.08)',
    shadowColorMd: 'rgba(0, 0, 0, 0.12)',

    // Escala de cinza (mantida para compatibilidade)
    grayScale: {
      base: '#1a1a1a',
      variation1: '#374151',
      variation2: '#4b5563',
      variation3: '#6b7280',
      variation4: '#9ca3af',
      variation5: '#d1d5db',
      variation6: '#e5e7eb',
      variation7: '#f3f4f6',
      variation8: '#f9fafb',
      variation9: '#fafafa',
      variation10: '#ffffff',
    },
  },

  fonts: {
    title: "'Inter', 'Roboto', sans-serif",
    text: "'Inter', 'Roboto', sans-serif",
  },

  sizes: {
    title: '28px',
    subTitle: '18px',
    text: '14px',
    header: '64px',
    sideBar: '230px',
    borderRadius: '8px',
    borderRadiusMd: '12px',
    borderRadiusLg: '16px',
  },

  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
    md: '0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)',
    lg: '0 10px 30px rgba(0,0,0,0.10), 0 4px 8px rgba(0,0,0,0.05)',
    focus: '0 0 0 3px rgba(87, 13, 33, 0.18)',
  },

  transitions: {
    fast: '0.15s ease',
    base: '0.25s ease',
    slow: '0.4s ease',
  },
};

export default theme;
